import { excludeNullishDataKeys, getCookieData, hasObjectValue, IS_CLIENT, META_PIXEL_ACTION_SOURCE, setCookieData } from '@repo/common-utils';

import { BZNAV_UTM_KEY, PARTNER_APP_LIST, WORKING_PLATFORM_KEY, WORKING_PLATFORM_URL_QUERY_KEY } from '../constants';
import { UtmData, WorkingPlatform } from '../types';

export const getClientWorkingPlatform = () => {
  if (!IS_CLIENT) return 'web';
  const savedWorkingPlatform = getCookieData(WORKING_PLATFORM_KEY);
  const workingPlatform = savedWorkingPlatform ? (savedWorkingPlatform as WorkingPlatform) : getUriWorkingPlatform();

  setCookieData(META_PIXEL_ACTION_SOURCE, PARTNER_APP_LIST.includes(workingPlatform) ? 'app' : 'website');

  return workingPlatform;
};

const getUriWorkingPlatform = (): WorkingPlatform => {
  const urlQuery = new URLSearchParams(window.location.search);
  let newWorkingPlatform = urlQuery.get(WORKING_PLATFORM_URL_QUERY_KEY) || 'web';
  if (urlQuery.get('grant_type') === 'sync_token') {
    newWorkingPlatform = 'kbank';
  }
  return newWorkingPlatform as WorkingPlatform;
};

export const getClientUtm = (): UtmData => {
  const savedSessionUtm: string | null = sessionStorage.getItem(BZNAV_UTM_KEY);
  let sessionUtm: UtmData | null = null;
  if (savedSessionUtm) {
    try {
      sessionUtm = JSON.parse(savedSessionUtm) as UtmData;
      if (hasObjectValue(sessionUtm) && sessionUtm.utmSource !== 'referer') {
        return sessionUtm;
      }
    } catch (error) {
      console.error('Error parsing savedSessionUtm:', error);
    }
  }

  const uriUtm = getUriUtm();
  if (hasObjectValue(uriUtm)) {
    return uriUtm;
  }

  const savedCookieUtm = getCookieData(BZNAV_UTM_KEY) as UtmData;
  if (savedCookieUtm && hasObjectValue(savedCookieUtm) && savedCookieUtm.utmSource !== 'referer') {
    return savedCookieUtm;
  }

  if (sessionUtm && hasObjectValue(sessionUtm)) {
    return sessionUtm;
  }

  let referer = document.referrer || window.location.origin;
  if (!referer.includes('?') && !referer.includes('#') && !referer.endsWith('/')) {
    referer += '/';
  }

  return { utmSource: 'referer', utmContent: referer };
};

const getUriUtm = () => {
  const urlQuery = new URLSearchParams(window.location.search.toLowerCase());

  return excludeNullishDataKeys({
    utmSource: urlQuery.get('utm_source') ?? undefined,
    utmMedium: urlQuery.get('utm_medium') ?? undefined,
    utmCampaign: urlQuery.get('utm_campaign') ?? undefined,
    utmContent: urlQuery.get('utm_content') ?? undefined,
    utmTerm: urlQuery.get('utm_term') ?? undefined
  }) as UtmData;
};
